/* eslint jsx-a11y/alt-text: 0 */
import React from "react"
import styled from "styled-components"
import {LegendItem} from "./LegendItem"

const Legend = (props) => {
  return (
    <OuterDiv>
      {props.items.map((item, key) => {
        return (
          <ItemDiv key={key}>
            <LegendItem
              color={item.color}
              label={item.label}
              value={item.value}
            />
          </ItemDiv>
        )
      })}
    </OuterDiv>
  )
}

const ItemDiv = styled.div`
  &:not(:last-of-type) {
    margin-bottom: 1em;
  }
`

const OuterDiv = styled.div`
  font-size: ${(props) => props.theme.fontSizeSmall}px;
`

Legend.defaultProps = {
  color: "#ddd",
  items: [],
}

export {Legend}
